import { c as _c } from "react/compiler-runtime";
import type { BlocksState } from '@/features/gen-ui';
import { useBlockContents } from '@/features/gen-ui';
import { BlocksPanelContent } from './blocks-panel-content';
import { EmptyState, LoadingState, PermissionErrorState } from './blocks-panel-states';
type BlocksPanelProps = {
  blocks: BlocksState;
  actionsDisabled?: boolean;
  pdfTargetRef?: React.Ref<HTMLDivElement>;
};
const BlocksPanel = t0 => {
  const $ = _c(11);
  const {
    blocks,
    actionsDisabled,
    pdfTargetRef
  } = t0;
  let t1;
  if ($[0] !== blocks.blocks) {
    t1 = blocks.blocks ?? [];
    $[0] = blocks.blocks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contents = useBlockContents(t1);
  if (contents.isLoading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <LoadingState />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!contents.blocks.length) {
    if (blocks.isLoading) {
      let t2;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <LoadingState />;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      return t2;
    }
    if (blocks.hasPermissionError) {
      let t2;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = <PermissionErrorState />;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      return t2;
    }
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyState />;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== actionsDisabled || $[7] !== blocks.deleteBlock || $[8] !== contents.blocks || $[9] !== pdfTargetRef) {
    t2 = <BlocksPanelContent blocks={contents.blocks} onDelete={blocks.deleteBlock} actionsDisabled={actionsDisabled} pdfTargetRef={pdfTargetRef} />;
    $[6] = actionsDisabled;
    $[7] = blocks.deleteBlock;
    $[8] = contents.blocks;
    $[9] = pdfTargetRef;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default BlocksPanel;